module.exports = __webpack_public_path__ + "static/sandrine_le_feur-6ffea7fb8ea7cc4ad68b05fd67fde00b.png";